module.exports = __webpack_public_path__ + "media/images/loof-1676b2697070943206e57600c2135f7f.jpg";